<template>
    <div class="pa-16">
        <h1>About Todo App</h1>
        <div>
            This is a to do app for task management which helps you to stay organized and manage your day to day task, you can plan an event, set reminders to increase your productivity and focus on what matters to you

        </div>
            <div>
            You can edit, delete task, add due dates and re order it according to your time table.
        
        </div>
    </div>
</template>


<script>
   
   export default{
       name:'About'
   }
</script>
